// extracted by mini-css-extract-plugin
module.exports = {"root":"TemplateDetailsForm_root__3uA6P","optionsWrapper":"TemplateDetailsForm_optionsWrapper__1qci-"};